import React from 'react'

const ProfileFormDropDown = ({items, value, change}) => {
    return (
        <>
                <select value={value} onChange={e => change(e.target.value)}   className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                    {items.map((item , index) => {
                        return (
                            <option key={index}>{item}</option>
                        )
                    })}
                </select>
        </>
    )
}
export default ProfileFormDropDown